/**
 * 将 File 对象转换为 Base64 字符串，并包含文件名信息
 * @param {File} file - 要转换的文件
 * @returns {Promise<string>} - 返回一个 Promise，解析为包含文件名信息的 Base64 字符串
 */
export default function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const base64String = reader.result;
      // 在 Base64 字符串中添加文件名信息
      const result = `data:${file.type};name=${file.name};base64,${base64String.split(',')[1]}`;
      resolve(result);
    };

    reader.onerror = error => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
}